<ziro-collapsible-section-card
  [isSwitchHidden]="true"
  [title]="'tkey;teams_call_queue.agents.header'"
  [subtext]="getHeaderSubtext()"
  [icon]="ziroIcons.AGENT_SMALL"
  [isCollapsible]="false"
>
  <ul
    ngbNav
    [activeId]="activeAgentMode"
    (navChange)="setAgentMode($event.nextId)"
    class="nav-pills px-4 mb-3"
    data-automation="agent-mode-tabs"
  >
    <li [ngbNavItem]="agentModes.USERS_AND_GROUPS" class="col-4">
      <a ngbNavLink class="btn nav-link text-center" data-automation="users-and-groups-tab">
        {{ 'tkey;teams_call_queue.agents.mode.users_and_groups.label' | translate }}
      </a>
    </li>
    <li [ngbNavItem]="agentModes.TEAMS_CHANNEL" class="col-4">
      <a ngbNavLink class="btn nav-link text-center" data-automation="teams-channel-tab">
        {{ 'tkey;teams_call_queue.agents.mode.teams_channel.label' | translate }}
      </a>
    </li>
    <li [ngbNavItem]="agentModes.SHIFTS" class="col-4">
      <a ngbNavLink class="btn nav-link text-center" data-automation="shifts-tab">
        {{ 'tkey;teams_call_queue.agents.mode.shifts.label' | translate }}
      </a>
    </li>
  </ul>

  @if (activeAgentMode === agentModes.USERS_AND_GROUPS) {
    <div class="d-flex justify-content-end mb-2 px-4">
      <div>
        <ziro-button
          [dataAutomation]="'add-agent'"
          [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
          [label]="'tkey;teams_call_queue.resource_accounts.add.user_group'"
          [icon]="ziroIcons.PLUS"
          (click)="agentPopover.toggle($event)"
        ></ziro-button>
      </div>
    </div>
    <p-popover
      #agentPopover
      [styleClass]="'agent-popover'"
      (onHide)="onPopoverClose(agentInput)"
      (onShow)="onAgentPopoverOpen()"
    >
      <div class="p-4" data-automation="agent-search-popover">
        <label class="w-100 typeahead-search input-group" id="agentTypeahead">
          <ng-template #rt let-r="result" let-t="term">
            <div [innerHTML]="r['markup'] | escapeHtml"></div>
          </ng-template>
          <input
            #agentInput
            [attr.data-automation]="'agent-type-ahead'"
            [class]="'w-100 form-control'"
            [ngClass]="{
              pending: isSearching,
            }"
            [type]="'text'"
            [ngbTypeahead]="agentSearch"
            [placeholder]="'tkey;teams_call_queue.resource_accounts.agent_search.placeholder' | translate"
            [focusFirst]="true"
            (selectItem)="addAgent($event.item)"
            [resultTemplate]="rt"
            [inputFormatter]="formatter"
          />
          @if (isSearching) {
            <i class="{{ ziroIcons.SAVING }} icon-warning fa-sm"></i>
          }
        </label>
        <div class="small form-text text-muted mt-1">
          {{ 'tkey;teams_call_queue.resource_accounts.agent_search' | translate }}
        </div>
      </div>
    </p-popover>
    <ziro-datatable
      [dataAutomation]="'agent-table'"
      [columns]="agentColumns"
      [rowDataSource]="agentRows()"
      [uniqueRowIdentifier]="null"
      [minTableHeight]="'12rem'"
      [containerCard]="true"
      [verticalAlignCellMiddle]="true"
      [setColumnWidths]="false"
    ></ziro-datatable>
  }

  <div [hidden]="activeAgentMode === agentModes.USERS_AND_GROUPS" class="px-4 pb-4">
    @if (isChannelConfigurationUnresolved()) {
      <div class="alert alert-warning" data-automation="channel-invalid-alert">
        <strong>{{ 'tkey;teams_call_queue.agents.channel.invalid.warning.title' | translate }}</strong>
        <p class="mb-0">{{ 'tkey;teams_call_queue.agents.channel.invalid.warning' | translate }}</p>
      </div>
    }

    <div class="row">
      <div class="col-6">
        <ziro-select [fieldId]="'teamId'" [inlineLabel]="false"></ziro-select>
      </div>
      <div class="col-6" [hidden]="activeAgentMode !== agentModes.TEAMS_CHANNEL">
        <ziro-select [fieldId]="'microsoftTeamsChannelId'" [inlineLabel]="false"></ziro-select>
      </div>
      <div class="col-6" [hidden]="activeAgentMode !== agentModes.SHIFTS">
        <ziro-select [fieldId]="'teamSchedulingGroupId'" [inlineLabel]="false"></ziro-select>
      </div>
    </div>
  </div>
</ziro-collapsible-section-card>
